module.exports = __webpack_public_path__ + "img/Menu-Icon-Small.4878468f.svg";